import React, { FunctionComponent } from "react";
import { Size } from "./types";
import { StyledLabel } from "./StyledLabel";

export const ButtonLabel: FunctionComponent<{
	label: string;
	size: Size;
	disabled?: boolean;
}> = ({ label, size, disabled }) => {
	return (
		<StyledLabel size={size} disabled={disabled}>
			{label}
		</StyledLabel>
	);
};
